export default __webpack_public_path__ + "static/tech-aws-43bfc090c06f02711452ed165987524a-43bfc090c06f02711452ed165987524a.png";